import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { PriScrollbarModule } from 'pri-ng-scrollbar';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import AppComponent from './app.component';
import { QUERY_SERVICE } from './app.tokens';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import { InitializerComponent } from './components/initializer/initializer.component';
import { LoginComponent } from './components/login/login.component';
import { TaxonomiesComponent } from './components/taxonomies/taxonomies.component';
import { WelcomeComponent } from './components/welcome/welcome.component';
import { ErrorInterceptor } from './interceptors/error.interceptor';
import { JwtInterceptor } from './interceptors/jwt.interceptor';
import { QueryService } from './services/query.service';
import { QueryServiceFake } from './services/query.service.fake';


@NgModule({
  declarations: [
    AppComponent,
    WelcomeComponent,
    HeaderComponent,
    FooterComponent,
    LoginComponent,
    InitializerComponent,
    TaxonomiesComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    ReactiveFormsModule,
    FormsModule,
    AppRoutingModule,
    PriScrollbarModule
  ],
  bootstrap: [
    AppComponent
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: QUERY_SERVICE, useClass: (environment.fakeData ? QueryServiceFake : QueryService) }
  ],
})
export default class AppModule { }
